{
  "title": "Denne siden er ikke klar enda",
  "description": "Vi jobber med å lage en ny versjon av denne siden. Inntil videre kan du bruke den i Skogmodul.",
  "buttonText": "Gå til Skogmodul"
}
